import React from 'react';
import {Radio} from 'antd';

const RadioGroup = Radio.Group;

const radioStyle = {
  display: 'block',
  height: '30px',
  lineHeight: '30px',
  textTransform: 'capitalize',
};

const RadioGroupComponent = (props) => {
  // console.log(props);
  return (
    <RadioGroup 
      onChange={props.onChange} 
      defaultValue={props.defaultValue}
      value={props.value}
      disabled={props.disabled}>
      {
        props.options.map((option, index)=>{
          return(
            <Radio key={index}
              style={radioStyle} 
              value={option}>{option}</Radio>
          )
        })
      }
    </RadioGroup>
  )
}

export default RadioGroupComponent;